interface IError {
    type: ErrorTypeEnum;
    id: number;
    datetime: string;
    context: string;
    url: string;
    parameters: string;
    stackTrace: string;
    errorMessage: string;
    userMessage: string;

    exception: any;
}

enum ErrorTypeEnum {
    Mapping,
    Workbook
}